import React from "react";
import IconSvg, { IconSvgProps } from "~/guidelines/Icon/IconSvg";

const Bed = ({ color }: IconSvgProps) => {
  return (
    <IconSvg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 6.5H19C21.21 6.5 23 8.29 23 10.5V18.5C23 19.05 22.55 19.5 22 19.5C21.45 19.5 21 19.05 21 18.5V16.5H3V18.5C3 19.05 2.55 19.5 2 19.5C1.45 19.5 1 19.05 1 18.5V5.5C1 4.95 1.45 4.5 2 4.5C2.55 4.5 3 4.95 3 5.5V13.5H11V8.5C11 7.4 11.9 6.5 13 6.5ZM10 9.5C10 11.16 8.66 12.5 7 12.5C5.34 12.5 4 11.16 4 9.5C4 7.84 5.34 6.5 7 6.5C8.66 6.5 10 7.84 10 9.5Z"
        fill="currentColor"
      />
    </IconSvg>
  );
};

export default Bed;
